export default "__VITE_ASSET__C6TTNh88__"